import { Component, inject } from '@angular/core';
import { AppGateStore, NoRolesAssignedComponent } from '@app/features/app-gate';
import { AppLayoutComponent } from './app-layout.component';

@Component({
  selector: 'app-app-shell',
  standalone: true,
  providers: [AppGateStore],
  imports: [AppLayoutComponent, NoRolesAssignedComponent],
  template: `
    @switch (gateStore.accessState()) {
      @case ('no-roles') {
        <app-no-roles-assigned />
      }
      @default {
        <app-app-layout />
      }
    }
  `,
})
export class AppShellComponent {
  protected readonly gateStore = inject(AppGateStore);
}
